import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import MDXRenderer from '../mdx/mdx-renderer';

export const Indications: React.FC<{}> = () => {
 	const indications = useStaticQuery(
		graphql`
			{
				mdx(internal: { contentFilePath: {regex: "/isi/indications/"}}) {
					body
				}
			}
		`
	);

	if (!indications.mdx) {
		console.warn('ISI indications content not configured.');
	}

	return (
		<>
			{indications.mdx && (
				<div className="prose prose-h3:text-brand prose-h3:text-base text-base">
					<MDXRenderer>{indications.mdx.body}</MDXRenderer>
				</div>
			)}
		</>
	);
};

export default Indications;
